import { ArbeitszeitReportFilters } from '@myapp/contract'
import { normalizeFilters } from '../../../shared/lib/normalizeFilters'

export const arbeitszeitReportKeys = {
  all: ['arbeitszeit-report'] as const,
  lists: () => [...arbeitszeitReportKeys.all, 'list'] as const,
  list: (filters?: ArbeitszeitReportFilters) =>
    [...arbeitszeitReportKeys.lists(), normalizeFilters(filters)] as const,
}
